import { ownerDocument } from './ownerDocument';
export function ownerWindow(node) {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
}